import GridLayout from "react-grid-layout";

export const MAINTENANCE_DASHBOARD_LAYOUT_CHANGED =
  "MAINTENANCE_DASHBOARD_LAYOUT_CHANGED";

export const createMaintenanceDashboardLayoutChangedAction = (
  payload: GridLayout.Layouts,
  initial: boolean = false
) => {
  return {
    type: MAINTENANCE_DASHBOARD_LAYOUT_CHANGED,
    payload,
    initial,
  };
};
